import React from 'react'
import { connect } from 'react-redux'
import { Button, Form, Modal } from '_zari/core'
import { Formik } from 'formik'
import { ZariContext } from '_zari/context'
import * as AuthService from 'services/auth.service'
import * as auth from 'store/ducks/auth.duck'
import * as FormGroups from './formGroups'

// Companias
const NuevoEgresoIngreso = ({ handleClose, show, ...props }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _idCompania: ''
    }
  }, [])

  const submitHandler = async ({ _idCompania }, { setSubmitting }) => {
    await AuthService.cambiarCompania({ idCompania: _idCompania })
      .then(({ data }) => {
        props.setToken(data.accessToken)
        window.location.href = '/'
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>CAMBIAR COMPAÑIA</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, touched, isSubmitting, handleSubmit }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CompaniaFormGroup fIsSubmitting={isSubmitting} iError={errors._idCompania} iTouched={touched._idCompania} />
            </Modal.Body>
            <Modal.Footer>
              <Button disabled={isSubmitting} color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Cambiar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default connect(null, auth.actions)(NuevoEgresoIngreso)
